
import React from "react";
import moment from "moment";
import withCandidate from "./withCandidate";

const TemplateBody = ({ candidate }) => {
  const languages = candidate?.languages || [];
  const skills = candidate?.skills || [];
  const work = candidate?.workExperiences || [];
  const educations = candidate?.educations || [];
  const references = candidate?.references || [];

  return (
    <>
      <style>{`
        /* =========================================================
           PALETTES DE THÈMES (appliquées via data-theme sur .template-page)
        ========================================================== */

        .template-page {
          --accent: #2379B8;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #0b1220;
          --chip: #1f2a44;
        }

        .template-page[data-theme="blue-pro"] {
          --accent: #2379B8;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #0b1220;
          --chip: #1f2a44;
        }

        .template-page[data-theme="slate"] {
          --accent: #64748b;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #0b1220;
          --chip: #1f2937;
        }

        .template-page[data-theme="emerald"] {
          --accent: #10b981;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #053429;
          --chip: #0a4c3d;
        }

        .template-page[data-theme="royal"] {
          --accent: #7c3aed;
          --ink: #1e1b4b;
          --muted: #6b6b9b;
          --paper: #ffffff;
          --panel: #1b1135;
          --chip: #2e1b59;
        }

        .template-page[data-theme="bordeaux"] {
          --accent: #b91c1c;
          --ink: #1f1f1f;
          --muted: #7a6565;
          --paper: #ffffff;
          --panel: #2b0d0d;
          --chip: #451414;
        }

        .template-page[data-theme="noir-or"] {
          --accent: #d4a017;
          --ink: #e5e5e5;
          --muted: #a3a3a3;
          --paper: #1b1b1b;
          --panel: #111111;
          --chip: #2a2a2a;
        }

        .template-page[data-theme="bleu-clair"] {
          --accent: #3b82f6;
          --ink: #1e293b;
          --muted: #64748b;
          --paper: #ffffff;
          --panel: #0f172a;
          --chip: #1e3a8a;
        }

        .template-page[data-theme="orange"] {
          --accent: #f97316;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #2a1505;
          --chip: #4a2c11;
        }

        .template-page[data-theme="teal"] {
          --accent: #0ea5a4;
          --ink: #0b2530;
          --muted: #5b7a85;
          --paper: #ffffff;
          --panel: #07333c;
          --chip: #0a4650;
        }

        .template-page[data-theme="forest"] {
          --accent: #22c55e;
          --ink: #10231b;
          --muted: #5f776e;
          --paper: #ffffff;
          --panel: #091c14;
          --chip: #113d2c;
        }

        .template-page[data-theme="rose"] {
          --accent: #e11d48;
          --ink: #2b0a13;
          --muted: #a36a7a;
          --paper: #ffffff;
          --panel: #1a0b11;
          --chip: #3a0f1c;
        }

        .template-page[data-theme="indigo"] {
          --accent: #4f46e5;
          --ink: #0f172a;
          --muted: #717ab9;
          --paper: #ffffff;
          --panel: #12163a;
          --chip: #212a6b;
        }

        .template-page[data-theme="malibaara"] {
          --accent: #2379B8;
          --ink: #0f172a;
          --muted: #6b7280;
          --paper: #ffffff;
          --panel: #0b1220;
          --chip: #1f2a44;
        }

        /* =========================================================
           LAYOUT & STYLE DU TEMPLATE
        ========================================================== */

        .tpl2 {
          width: 210mm;
          min-height: 297mm;
          margin: 10px 0;
          background: var(--paper);
          box-shadow: 0 10px 30px rgba(0,0,0,.12);
        }

        body { background:#222; }

        .tpl2 .grid {
          display: grid;
          grid-template-columns: 260px 1fr;
          min-height: 297mm;
        }

        .tpl2 .side {
          background: var(--panel);
          color: #fff;
          padding: 28px 22px;
        }

        .tpl2 .avatar {
          width: 120px;
          height: 120px;
          border-radius: 50%;
          overflow: hidden;
          border: 2px solid #1f2937;
          margin: 8px auto 12px;
        }

        .tpl2 .avatar img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .tpl2 .name {
          font-size: 22px;
          font-weight: 800;
          text-align: center;
        }

        .tpl2 .title {
          text-align: center;
          opacity: .8;
          font-size: 12px;
        }

        .tpl2 h4 {
          font-size: 11px;
          text-transform: uppercase;
          letter-spacing: 1px;
          margin: 18px 0 8px;
          opacity: .9;
          color: white;
          font-weight: bold;
        }

        .tpl2 .contact {
          font-size: 12px;
          line-height: 1.5;
        }

        .tpl2 .chips {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
        }

        .tpl2 .chip {
          font-size: 11px;
          padding: 4px 8px;
          background: var(--chip);
          border-radius: 999px;
        }

        /* LANGUES */
        .tpl2 .lang-list { display: grid; gap: 6px; font-size:12px; }
        .tpl2 .lang-item { line-height: 1.35; }
        .tpl2 .lang-name { font-weight:600; color:#e5e7eb; }
        .tpl2 .lang-meta { color:#cbd5e1; }
        .tpl2 .lang-sep { margin:0 6px; opacity:.6; }

        /* MAIN */
        .tpl2 .main { padding: 26px 28px; color: var(--ink); }

        .tpl2 .header {
          border-bottom:2px solid var(--accent);
          padding-bottom:8px;
          margin-bottom:10px;
          display:flex;
          justify-content:space-between;
          align-items:flex-end;
        }

        .tpl2 .headline {
          font-size:26px;
          font-weight:900;
        }

        .tpl2 .meta {
          color:var(--muted);
          font-size:13px;
        }

        .tpl2 .section-title {
          color:var(--accent);
          text-transform:uppercase;
          font-size:12px;
          margin:14px 0 8px;
        }

        /* TIMELINE */
        .tpl2 .timeline {
          position:relative;
          padding-left:20px;
        }

        .tpl2 .timeline:before {
          content:"";
          position:absolute;
          left:8px;
          top:2px;
          bottom:2px;
          width:2px;
          background:#dbeafe;
        }

        .tpl2 .item {
          position:relative;
          margin-bottom:12px;
          padding-left:14px;
        }

        .tpl2 .dot {
          position:absolute;
          left:-16px;
          top:3px;
          width:10px;
          height:10px;
          background:var(--accent);
          border-radius:50%;
        }

        .tpl2 .row {
          display:flex;
          justify-content:space-between;
          font-weight:700;
          position:relative;
        }

        .tpl2 .sub {
          font-size:12px;
          color:var(--muted);
          white-space:nowrap;
        }

        .tpl2 p {
          margin-top:4px;
          font-size:13px;
          color:#4b5563;
        }
      `}</style>

      <div className="wrap tpl2">
        <div className="grid">

          {/* ===================== SIDEBAR ===================== */}
          <aside className="side">
            <div className="avatar">
              <img
                crossOrigin="anonymous"
                src={candidate?.profilePictureUrl || "/assets/images/avatar/avatar2.png"}
                alt=""
              />
            </div>

            <div className="name">
              {candidate?.firstName} {candidate?.lastName}
            </div>

            <h4>Contact</h4>
            <div className="contact">
              <div>{candidate?.email}</div>
              <div>{candidate?.phoneNumber1}</div>
            </div>

            {!!skills?.length && (
              <>
                <h4>Compétences</h4>
                <div className="chips">
                  {skills.map((s, i) => (
                    <span className="chip" key={i}>{s?.title}</span>
                  ))}
                </div>
              </>
            )}

            {!!languages?.length && (
              <>
                <h4>Langues</h4>
                <div className="lang-list">
                  {languages.map((l, i) => {
                    const parts = [];
                    if (l?.percentage) parts.push(`${l.percentage}%`);
                    if (l?.writingLevel) parts.push(`Écrit : ${l?.writingLevel}`);
                    if (l?.speakingLevel) parts.push(`Parlé : ${l?.speakingLevel}`);

                    const meta = parts.join(" • ");

                    return (
                      <div className="lang-item" key={i}>
                        <span className="lang-name">{l?.name}</span>
                        {meta && (
                          <>
                            <span className="lang-sep">—</span>
                            <span className="lang-meta">{meta}</span>
                          </>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </aside>

          {/* ===================== MAIN ===================== */}
          <main className="main">

            <div className="header">
              <div className="headline">{candidate?.firstName} {candidate?.lastName}</div>
              <div className="meta">{candidate?.email} · {candidate?.phoneNumber1}</div>
            </div>

            {/* PROFIL */}
            <section>
              <div className="section-title">Profil</div>
              <div
                dangerouslySetInnerHTML={{ __html: candidate?.summaryDescription || "" }}
              />
            </section>

            {/* EXPÉRIENCES */}
            {!!work?.length && (
              <section>
                <div className="section-title">Expériences</div>
                <div className="timeline">
                  {work.map((job, i) => (
                    <div className="item" key={i}>
                      <span className="dot" />
                      <div className="row">
                        <div>{job?.title}</div>
                        <div className="sub">
                          {moment(job?.startDate).format("DD MMM YYYY")} –{" "}
                          {job?.endDate ? moment(job?.endDate).format("DD MMM YYYY") : "Aujourd’hui"}
                        </div>
                      </div>
                      {job?.description && <p>{job?.description}</p>}
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* FORMATION */}
            {!!educations?.length && (
              <section>
                <div className="section-title">Formation</div>
                <div className="timeline">
                  {educations.map((edu, i) => (
                    <div className="item" key={i}>
                      <span className="dot" />
                      <div className="row">
                        <div>{edu?.degree}</div>
                        <div className="sub">{edu?.startYear} – {edu?.endYear}</div>
                      </div>
                      {edu?.description && <p>{edu?.description}</p>}
                    </div>
                  ))}
                </div>
              </section>
            )}

            {/* REFERENCE */}
            {!!references?.length && (
              <section>
                <div className="section-title">Références</div>
                <div className="timeline">
                  {references.map((ref, i) => (
                    <div className="item" key={i}>
                      <span className="dot" />
                      <div className="row">
                        <div>{ref?.fullName}</div>
                        <div className="sub">{ref?.title}</div>
                      </div>
                      <p>
                        Tel: {ref.phoneNumber1} / {ref.phoneNumber2} <br />
                        Email: {ref.email}
                      </p>
                    </div>
                  ))}
                </div>
              </section>
            )}

          </main>
        </div>
      </div>
    </>
  );
};

export default withCandidate(TemplateBody, "Modern Deux Colonnes 1");
